import { render, staticRenderFns } from "./frontendFooter.vue?vue&type=template&id=67696162&"
import script from "./frontendFooter.vue?vue&type=script&lang=js&"
export * from "./frontendFooter.vue?vue&type=script&lang=js&"
import style0 from "./frontendFooter.vue?vue&type=style&index=0&id=67696162&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports